'use client'

import { Button } from '@/shared/ui/button'
import { cn } from '@/utils/cn'
import AlarmPrimary from '@/shared/ui/icons/alarm-primary.svg'
import { NotificationButtonProps } from '..'

export const NotificationFullButton = ({
  id,
  price,
  priceLowest,
  notifiedStatus,
  onClickNotificationButton,
  className,
  ...props
}: NotificationButtonProps) => {
  return (
    <Button
      variant={notifiedStatus === 'notified' ? 'outlinePrimary' : 'primary'}
      size="lg"
      onClick={onClickNotificationButton}
      className={cn(className, 'w-full items-center gap-2')}
      {...props}
    >
      <span>
        쿠팡 최저가 알림
        {notifiedStatus === 'notified' ? '받는중' : '받기'}
      </span>
      <AlarmPrimary className="size-4" />
    </Button>
  )
}
